// @flow
import React from "react";
import Webcam from "react-webcam";

import "./VideoRecorder.scss";

type Props = {
    onRecorded: Function,
    audio: boolean,
    onRecordingStarted: Function,
    onRecordingStopped: Function,
    record: boolean,
    onError: Function
    
};

type State = {};

export default class VideoRecorder extends React.PureComponent<Props, State> {
    webcamRef: ?Webcam;
    mediaStream: ?MediaStream;
    mediaRecorder: ?MediaRecorder;
    recordedChunks: Array<Blob>;
    isRecording: boolean = false;
    
    handleOnUserMedia = () => {
        if (this.webcamRef) {
            this.mediaStream = this.webcamRef.stream;
        }
    };

    handleOnUserMediaError = (error: MediaStreamError) => {
        this.props.onError("Cannot access video: " + error.toString());
    };

    setWebcamRef = (webcam: Webcam) => {
        this.webcamRef = webcam;
    };

    componentDidMount() {
        if (this.props.record) {
            this.startRecording();
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.record && !prevProps.record) {
            this.startRecording();
        } else if (!this.props.record && prevProps.record) {
            this.stopRecording();
        }
    }

    render = () => {
        const videoConstraints = {
            width: 868
            //  height: 720
        };

        return (
            <Webcam
                videoConstraints={videoConstraints}
                audio={this.props.audio}
                onUserMedia={this.handleOnUserMedia}
                onUserMediaError={this.handleOnUserMediaError}
                ref={this.setWebcamRef}
                width="auto"
                height="auto"
            />
        );
    };

    startRecording = () => {
        if (!this.mediaStream) {
            this.props.onError("Cannot record. No video stream.");
            return;
        }

        if (typeof WebAssembly !== "object") {
            this.props.onError(
                "Your browser does not support video recording."
            );
            return;
        }

        // 30s recording
        // -------------
        // - video/webm;codecs=vp9   4589163 ~(-)30%
        // - video/webm;codecs=h264  5644770 ~(-)17%
        // - video/webm;codecs=vp8   6759569 >1%
        // - video/webm;codecs=opus  6855949 >1%
        // - video/webm              6816883

        let streamOptions = { mimeType: "video/webm" };
        // https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder/isTypeSupported
        if (typeof MediaRecorder.isTypeSupported === 'function'){
			if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
			  streamOptions = {mimeType: 'video/webm;codecs=vp9'};
            } else if (MediaRecorder.isTypeSupported('video/webm;codecs=h264')) {
			  streamOptions = {mimeType: 'video/webm;codecs=h264'};
            }
		}

        this.mediaRecorder = new MediaRecorder(this.mediaStream, streamOptions);
        this.recordedChunks = [];
        this.mediaRecorder.onstop = this.handleStoppedRecording;
        this.mediaRecorder.ondataavailable = this.handleRecordedData;
        this.mediaRecorder.onerror = this.handleRecordingError;
        this.isRecording = true;
        this.mediaRecorder.start(100);
        this.props.onRecordingStarted();
    };

    stopRecording = () => {
        this.isRecording = false;
        if (this.mediaRecorder) {
            this.mediaRecorder.stop();
        }
    };

    handleStoppedRecording = () => {
        this.isRecording = false;
        this.props.onRecordingStopped();
        this.props.onRecorded(
            new File(this.recordedChunks, "video.webm", { type: "video/webm" })
        );

        //Cleanup
        if (this.mediaRecorder) {
            this.mediaRecorder.onstop = null;
            this.mediaRecorder.ondataavailable = null;
            this.mediaRecorder.onerror = null;
            this.mediaRecorder = null;
            this.recordedChunks = [];
        }
    };

    handleRecordedData = (e: BlobEvent) => {
        this.recordedChunks.push(e.data);
    };

    handleRecordingError = e => {
        this.props.onError("Recording error");
    };
}



// WEBPACK FOOTER //
// ./src/app/components/MediaRecorder/VideoRecorder/VideoRecorder.js